import React, { useMemo } from 'react';
import { ItineraryItem } from '../../types/Quotation';
import { formatDate, formatTime } from '../../utils/date';

interface FlightTableProps {
  itinerary: ItineraryItem[];
  onRemove?: (dayIndex: number, flightIndex: number) => void;
  hideActions?: boolean;
}

export const FlightTable: React.FC<FlightTableProps> = ({ itinerary, onRemove, hideActions = false }) => {
  const allFlights = useMemo(
    () => itinerary.flatMap((item, dayIndex) =>
      item.flights.map((fl, flightIndex) => ({
        ...fl,
        day: item.day,
        dayIndex,
        flightIndex,
      }))
    ),
    [itinerary]
  );

  if (allFlights.length === 0) return null;

  return (
    <table className="flight-table">
      <thead>
          <tr>
            <th>Date</th>
            <th>Carrier</th>
            <th>Flight</th>
            <th>From</th>
            <th>To</th>
            <th>Schedule</th>
            <th>Price</th>
            {!hideActions && <th>Action</th>}
          </tr>
      </thead>
      <tbody>
        {allFlights.map((fl, idx) => (
          <tr key={idx}>
            <td>{formatDate(fl.departureTime)}</td>
            <td>
              <img
                src={`https://cdn.otaprime.com/airline/${fl.provider}.gif`}
                alt={fl.airline}
                className="flight-logo"
              />
              <span> {fl.airline} </span>
            </td>
            <td>{fl.provider}-{fl.flightNumber}</td>
            <td>{fl.from}</td><td>{fl.to}</td>
            <td className="schedule-cell">
              <div className="dep-time">{formatTime(fl.departureTime)}</div>
              <div className="middle">
                <span className="duration">{fl.duration}</span>
                <span className="stops">
                  {fl.stops > 0 ? `${fl.stops} stop${fl.stops > 1 ? 's' : ''}` : 'Non‑stop'}
                </span>
              </div>
              <div className="arr-time">{formatTime(fl.arrivalTime)}</div>
            </td>
            <td>₹{fl.price.toLocaleString('en-IN')}</td>
            {!hideActions && onRemove && (
            <td>
              <button onClick={() => onRemove(fl.day - 1, fl.flightIndex)}>×</button>
            </td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};